import { huabanArtHost } from "@/utils/host";
import { useMemo } from "react";

//需求地址： https://doc.huanleguang.com/pages/viewpage.action?pageId=475491554#:~:text=%E6%9C%AC%E6%9C%9F%E4%B8%8D%E6%94%AF%E6%8C%81%EF%BC%89-,%E5%85%A8%E5%B1%8F%E7%89%88%E8%AF%A6%E6%83%85%E9%A1%B5,-%E9%87%87%E9%9B%86%E4%BF%A1%E6%81%AF
export function usePinArtLink(pin: IPin) {
  const link = useMemo(() => {
    if (!pin?.file_art) {
      return pin?.link;
    }

    if (pin.file_art.relate_tools === "make-similar") {
      if (pin.file_art.extra?.relate_template_id) {
        return `https://${huabanArtHost}/inspirations/${pin.file_art.extra.relate_template_id}?post_id=${pin.file_art.content_id}`;
      }
      return `https://${huabanArtHost}/inspirations/${pin.file_art.content_id}`;
    }

    if (pin.file_art.relate_tools === "image") {
      return `https://${huabanArtHost}/editor/canvas?type=board&mode=copy_community&id=${pin.file_art.content_id}`;
    }

    return (
      pin.link ||
      `https://${huabanArtHost}/inspirations/${pin.file_art.content_id}`
    );
  }, [pin]);

  return link;
}
